import BlackButton from '../custom-components/BlackButton';
import CloseButton from '../custom-components/CloseButton';

function ErrorAlert({ show, onClickHandle, title, subTitle }) {
  if (!show) {
    return null;
  }
  return (
    <div className="modal">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="form-header">
          <div className="header">{title}</div>
          <CloseButton onClickhandle={() => onClickHandle()} />
        </div>
        <div className="form-container">
          <div
            style={{
              display: 'flex',
              marginTop: 20,
              fontSize: 16,
              fontWeight: 400,
              color: '#474747',
            }}
          >
            {subTitle}
          </div>
          <div className="footer-button-container">
            <BlackButton onClickhandle={() => onClickHandle()}>Ok</BlackButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorAlert;
